import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
const propTypes = {
  /**
   * Column metadata
   */
  columns: PropTypes.arrayOf(PropTypes.object).isRequired,
  /**
   * An array of information that defines the footer content and layout
   *
   * ```
   * {
   *     content: string,
   *     isLabel: optional boolean,
   *     empty: optional boolean,
   *     colSpan: optional number
   * }
   * ```
   */
  footer: PropTypes.arrayOf(PropTypes.object).isRequired,
  /**
   * The number of columns docked to the left of the table
   */
  fixedColumnCount: PropTypes.number.isRequired,
  /**
   * Object of theme-like props that will not change after the component mounts
   */
  theme: PropTypes.shape({
    /**
     * Table background color
     */
    backgroundColor: PropTypes.oneOf(['white', 'gray-05', 'gray-10']),
    /**
     * Dock the header to the top or the footer to the bottom when scrolling
     */
    fixedRows: PropTypes.oneOf(['header', 'footer', 'both', ''])
  })
};
function TableFooter(_ref) {
  let {
    footer,
    fixedColumnCount,
    columns,
    theme = {
      backgroundColor: 'white',
      fixedRows: ''
    }
  } = _ref;
  const {
    backgroundColor,
    fixedRows
  } = theme;
  const isFixed = fixedRows === 'footer' || fixedRows === 'both';
  const hasFixedColumns = fixedColumnCount > 0;
  let columnPosition = columns[0].hidden ? 1 : 0;
  const footerClassNames = cx('asc-table-component-footer', {
    'asc-table-component-footer--fixed': isFixed
  });
  return /*#__PURE__*/React.createElement("tfoot", {
    className: footerClassNames
  }, /*#__PURE__*/React.createElement("tr", null, columns[0].hidden && /*#__PURE__*/React.createElement("td", {
    className: "asc-acc-hidden"
  }), footer.map((footerField, index) => {
    let colSpan = footerField.colSpan ? footerField.colSpan : 1;
    let key = 'footer-' + index;
    let isColumnFixed = hasFixedColumns && columns[columnPosition].fixed;
    let footerClassNames = cx('asc-table-component-footer-cell', `asc-table--bg-${backgroundColor}`, {
      'asc-table-component-cell--fixed': isColumnFixed,
      'asc-table-component-cell--fixed-last': isColumnFixed && columnPosition + colSpan >= fixedColumnCount
    });
    let cellStyles = {};
    if (isColumnFixed && columns[columnPosition].left) {
      cellStyles.left = columns[columnPosition].left;
    }
    columnPosition = columnPosition + colSpan;
    return footerField.isLabel ? /*#__PURE__*/React.createElement("th", {
      key: key,
      colSpan: colSpan,
      className: footerClassNames,
      style: cellStyles
    }, footerField.content) : /*#__PURE__*/React.createElement("td", {
      key: key,
      colSpan: colSpan,
      className: footerClassNames,
      style: cellStyles
    }, footerField.empty ? '' : footerField.content);
  })));
}
TableFooter.propTypes = propTypes;
export default TableFooter;